<div class="text-primary">
  <div class="p-0 d-flex flex-wrap flex-column justify-content-around align-items-center">
    <ng-container *ngIf="card$ | async as card">
      <ng-container *ngIf="member$ | async as member">
        <!-- Not Owner Barcode Body -->
        <div
          class="w-100 bg-primary barcode-content-container pt-3"
          [ngClass]="{
            'bg-primary': isKid
          }"
        >
          <div class="container barcode-content font-size-14 pb-3 text-white">
            <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="card$ | async as card">
              <!--Name and ID-->
              <div
                class="card-id text-start"
                [ngClass]="{
                  'text-white': isKid
                }"
              >
                <h5 class="mb-1 card-name" *ngIf="memberDetails$ | async as memberDetails">
                  {{ memberDetails.FirstName }} {{ memberDetails.Surname | slice : 0 : 1 }}.
                </h5>
                <div class="d-flex font-size-12">
                  <ng-container *inPopulation="[populations.Default, populations.Club1901]">
                    <div>{{ 'product.code.member' | translate }}</div>
                  </ng-container>

                  <ng-container *inPopulation="populations.Kids">
                    <div>{{ 'product.code.kids' | translate }}</div>
                  </ng-container>
                  <div class="px-1">-</div>
                  <div>{{ card.ExternalRefNumber }}</div>
                </div>
              </div>
              <ng-container *ngIf="!isWalletPage">
                <div
                  class="btn btn-secondary fw-bold d-flex align-items-center"
                  [routerLink]="'/rewards/wallet'"
                  [ngClass]="{
                    'bg-secondary': isKid
                  }"
                >
                  <span class="icon material-icons pe-2">qr_code</span>
                  <span class="text-uppercase">{{ 'barcode.reward.btn' | translate }}</span>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="isWalletPage">
              <div class="qr mt-3 mb-2 bg-white d-flex justify-content-center rounded" *ngIf="barcode$ | async as barcode">
                <qrcode [qrdata]="barcode.Barcode" [width]="135" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
                <div class="text-black font-size-12">Scan Member Barcode</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isWalletPage && !isMenu">
              <ng-container class="mb-1 card-name" *ngIf="memberDetails$ | async as memberDetails">
                <ng-container *ngIf="memberDetails.kidType == KidType.AllStars">
                  <img class="banner-img" src="assets/images/welcome-banner-all-star.jpg" alt="welcome-banner-all-star" />
                </ng-container>
                <ng-container *ngIf="memberDetails.kidType == KidType.Junior">
                  <img class="banner-img" src="assets/images/welcome-banner-junior.jpg" alt="welcome-banner-junior" />
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
